import React, { useContext } from "react";
import axios from "axios";
import { Box, Button, List, ListItem, ListItemText, TextField } from "@mui/material";
import container from "../../../../styles/Global.module.css";
import { Months } from "../../../../json/Months";
import { useCustomState } from "../../../../utils/useCustomState.js";
import { UserContext } from "../../../../UserContext.js";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const Incrusted = () => {

    const apiUrl = `${backendUrl}/api/`;
    const { key, setKey } = useContext(UserContext);
    setKey(localStorage?.getItem("jwt"));

    const [state, updateState] = useCustomState({
        isSubmitting: false,
        month: "",
        monthsList: false,
        offer_id: null,
        iframeUrl: null
    });

    const handleSelectOfferID = (e) => {
        updateState({ offer_id: e.target.value });
    };

    const handleMonthSelect = (month) => {
        updateState({
            month,
            monthsList: false,
        });
    };

    const handleMonthsList = () => {
        updateState({ monthsList: !state.monthsList });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        updateState({ isSubmitting: true });

        try {
            const headers = {
                Accept: "*/*",
                Authorization: `Bearer ${localStorage?.getItem("jwt")}`,
            };
            const reqOptions = {
                url: `${apiUrl}dashboards?offer_id=${state.offer_id}&month=${state.month}`,
                method: "GET",
                headers
            };

            const res = await axios.request(reqOptions);
            updateState({ iframeUrl: res.data })
        } catch (error) {
            console.error("Error al obtener el iframe URL:", error);
        }
    };

    return (
        <Box
            className={container.globalContainer}
            style={{ padding: "15px 30px" }}
            component="form"
        >
            {!state.iframeUrl && (<p>Cargando dashboard...</p>)}
            <div style={{ display: "flex" }}>
                <TextField
                    label="Offer ID"
                    variant="outlined"
                    value={state.offer_id}
                    onChange={handleSelectOfferID}
                    type="number"
                    sx={{
                        backgroundColor: "white",
                        position: "relative",
                        marginRight: "10px",
                    }}
                />

                <div>

                    <TextField
                        label="Month"
                        variant="outlined"
                        value={state.month}
                        onClick={handleMonthsList}
                        sx={{
                            backgroundColor: "white",
                            position: "relative",
                            marginRight: "10px",
                            width: "100px",
                        }}
                    />
                    {state.monthsList && (
                        <List
                            component="ul"
                            className="autocomplete-ul"
                            sx={{
                                width: "100px",
                                zIndex: "9999",
                                position: "absolute",
                            }}
                        >
                            {Months.map((m, index) => (
                                <ListItem
                                    key={index}
                                    onClick={() => handleMonthSelect(m.number)}
                                    className="autocomplete-li"
                                    sx={{
                                        color: "black",
                                        fontWeight: "700",
                                        margin: "3px 0px",
                                        padding: "5px",
                                        "&:hover": {
                                            backgroundColor: "var(--blueLowTwo)",
                                        },
                                    }}
                                >
                                    <ListItemText primary={m.label} />
                                </ListItem>
                            ))}
                        </List>
                    )}
                </div>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    type="submit"
                    sx={{ height: "auto", width: "200px" }}
                // disabled={state.excelData === null}
                >
                    Generar
                </Button>
            </div>
            <iframe
                src={state.iframeUrl}
                frameborder="0"
                width="100%"
                height="800"
                allowtransparency
            ></iframe>
        </Box>


    )
}

export default Incrusted;
